const client = require("@sanity/client");

import imageUrlBuilder from "@sanity/image-url";
import { SanityImageSource } from "@sanity/image-url/lib/types/types";

export const sanityClient = client({
  projectId: process.env.GATSBY_SANITY_PROJECT_ID ?? "tdld5dwk",
  dataset: process.env.GATSBY_SANITY_DATASET ?? "production",
  useCdn: true,
  apiVersion: "2021-03-25",
});

export const imageBuilder = imageUrlBuilder(sanityClient).auto("format");

export function urlForImageRef(source?: Queries.SanityImageAsset) {
  if (!source) return null;
  return imageBuilder.image(source as SanityImageSource);
}
